import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { User } from '@/types';

interface UserState {
  users: User[];
}

const initialState: UserState = { users: [] };

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUsers(state, action: PayloadAction<User[]>) {
      state.users = action.payload;
    },
    addUser(state, action: PayloadAction<User>) {
      state.users.push(action.payload);
    },
    removeUser(state, action: PayloadAction<number>) {
      state.users = state.users.filter((u) => u.id !== action.payload);
    },
    editUser(state, action: PayloadAction<User>) {
      const i = state.users.findIndex((u) => u.id === action.payload.id);
      if (i !== -1) state.users[i] = action.payload;
    },
  },
});

export const { setUsers, addUser, removeUser, editUser } = userSlice.actions;
export default userSlice.reducer;
